import React from "react";
import Image from "react-bootstrap/Image";
import Col from "react-bootstrap/Col";
import { NavLink, useHistory } from "react-router-dom";
// import AddIconListSuperAdmin from "../reusablePopupSuperAdmin/AddIconListSuperAdmin";
// import AddRatingReviewPopup from "../reusablePopupSuperAdmin/ratingAndReviews/AddRatingReviewPopup";
// import AddSuggestion from "../../superAdminAllComponent/superAdminSuggestion/InsideComponent/AddSuggestion";
// import AddOpenIssues from "../../superAdminAllComponent/superAdminOpenIssuesUsers/InsideAllPageComponent/AddOpenIssues";
// import AddOpenIssuesVendor from "../../superAdminAllComponent/superAdminOpenIssuesVendor/InsideAllPageComponent/AddOpenIssuesVendor";
// import { NavLink } from "react-router-dom";
// import AddReferralsPopup from "../../superAdminAllComponent/superAdminRefferalsCode/referralsPopup/AddReferralsPopup";
// import AddReferreePopup from "../../superAdminAllComponent/superAdminRefferalsCode/referralsPopup/AddReferreePopup";
// import OfferPopup from "../../../reusableComponents/allPopupReusable/offerEventPopup/OfferPopup";
// import AddOfferSuperAdminRestaurant from "../../superAdminAllComponent/superAdminRestaurantOffers/popup/AddOfferSuperAdminRestaurant";

const HomeReusableTopBarNavigation = (props) => {

  const history = useHistory();

  const goBack = () => {
    history.goBack();
  }

  const goBackState = () => {
    history.push(props.link, {back:true});
  }

  return (
    <React.Fragment>
      <Col className="home-reusable-top-bar">
        {props.backIcon && (
          <div className="f12-500 enBackLink" onClick={goBack}>
            <Image
              fluid
              alt="Back Icon"
              title="Back Icon"
              className="mr-2"
              src={require("../../../../assets/images/UserManagement/backIcon.svg")}
            />
            {props.displayText}
          </div>
        )}

        {props.backState && (
          <div className="f12-500 enBackLink" onClick={goBackState}>
            <Image
              fluid
              alt="Back Icon"
              title="Back Icon"
              className="mr-2"
              src={require("../../../../assets/images/UserManagement/backIcon.svg")}
            />
            {props.displayText}
          </div>
        )}

        <Col className="d-flex align-items-center justify-content-end">
          <div className="f14-700 mr-2">Super Admin</div>
          <div className="enAdminPic">
            <Image
              src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
              alt="Profile pic"
              title="Profile Pic"
              fluid
              className="m-0"
            />
          </div>
        </Col>
      </Col>
      {/* <Col className="home-reusable-top-bar">
        <Col>
          <div className="d-flex align-items-center">
            {this.props.displayBack ? (
              <NavLink to={this.props.backButtonLink}>
                <Image
                  fluid
                  alt="Back Icon"
                  title="Back Icon"
                  className="back-button-image"
                  src={require("../../../../assets/images/ActionImages/backbuttonnew.png")}
                />
              </NavLink>
            ) : null}
            <h5>{this.props.displayText}</h5>
          </div>
        </Col>
        <Col className="d-flex justify-content-end">
          {this.props.displayButton === "addIcon" ? (
            <AddIconListSuperAdmin />
          ) : null || this.props.displayButton === "addReview" ? (
            <AddRatingReviewPopup />
          ) : null || this.props.displayButton === "addSuggestion" ? (
            <AddSuggestion />
          ) : null || this.props.displayButton === "addUserIssues" ? (
            <AddOpenIssues />
          ) : null || this.props.displayButton === "addVendorIssues" ? (
            <AddOpenIssuesVendor />
          ) : null || this.props.displayButton === "addReferrals" ? (
            <div className="w-75 d-flex align-items-center justify-content-between">
              <AddReferralsPopup />
              <AddReferreePopup />
            </div>
          ) : null || this.props.displayButton === "addOffers" ? (
            <OfferPopup bigText="Add New Offer" />
          ) : null ||
            this.props.displayButton === "superAdminRestaurantOffers" ? (
            <AddOfferSuperAdminRestaurant bigText="New Offers" />
          ) : null}
        </Col>
      </Col> */}
    </React.Fragment>
  );
};

export default HomeReusableTopBarNavigation;
